export default "__VITE_PUBLIC_ASSET__03d122d7__"